export default __webpack_public_path__ + "static/media/logo.b601c53f.png";